import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, Switch,
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem, Image, Textarea } from "@chakra-ui/react";
import { TopDisplay,UploadButton } from "../../../components";
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect} from "react";
// import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../components';
import { MdMoreVert as MoreIcon } from "react-icons/md";
import { BatchInvite } from "./Modal";
import { Loader } from "../../../customs";
import { FcInvite as InviteIcon} from "react-icons/fc";
import apiCall from '../../../utils/apiCall';
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import {useAtom,atom} from 'jotai'
import { modalAtom, openAtom, notificationAtom, openNAtom } from "../../../context";
import { format } from "date-fns";
import * as Yup from 'yup';
import styled from "@emotion/styled";
import {Transcript} from './Modal';
import { FaRegFileAlt, FaRegFileAlt as FileIcon } from "react-icons/fa";
import { DocumentViewer} from "./Modal";
import { useDocumentModal } from "../../../hooks/UseDocumentModal";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";


const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function GenTranscript() {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const [,set_modal] = useAtom(modalAtom);
    const [,set_open] = useAtom(openAtom);
      const [,set_n_open] = useAtom(openNAtom);
      const [,set_notification] = useAtom(notificationAtom);
      const queryClient = useQueryClient();
  const [selected_status,set_selected_status] = useState<null | string>(null);

  const { isLoading: statusLoading, mutate: update_status } = useMutation({
  mutationKey: ['update-transcript-status'],
 mutationFn: async (payload: any) => {
  return await apiCall().put(
    `/Exam/UpdateTranscriptRequestStatus?id=${payload.id}&status=${payload.status}`,
    {}
  );
  },
  onSuccess(data: any) {
    set_notification({
      type: 'success',
      message: data.data.Message || 'Status updated successfully',
    });

    queryClient.invalidateQueries(['approve-request']);

    set_n_open(true);
  },
  onError(error: any) {
    set_notification({
      type: 'error',
      message:
        error?.response?.data?.Message ||
        'Error updating transcript status',
    });

    set_n_open(true);
  },
});

  const {isLoading,data:all_approved_transcript_request} = useQuery(['approve-request'],{
    queryFn:async ()=> await apiCall().get(`/Exam/AllApprovedAndCompletedPaymentsTranscriptRequests`),
    select(data){
    //  console.log(data,'transcript')
      return data.data.Data;
    }
  })
  const [search,set_search] = useState('');

  const handleSearch = (e:any)=>{
    let val = e.target.value;
    set_search(val);
    if(val){
      let new_data = filter_data?.filter((eData:any) => Object.values(eData).join(all_approved_transcript_request).toLowerCase().includes(val.toLowerCase()) );
      if(new_data.length > 0)set_filter_data(new_data)
      else set_filter_data(all_approved_transcript_request)
    }
    else set_filter_data(all_approved_transcript_request)
  }


  const [filter_data,set_filter_data] = useState<any>(all_approved_transcript_request);

  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);

  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };



  useEffect(()=>{
    if(selected_status){
      let data = all_approved_transcript_request.filter((eData:any) => eData.Status === selected_status);
      if(data.length > 0){
        set_filter_data(data);
      }
    }
    else{
      set_filter_data(all_approved_transcript_request);
    }
  },[selected_status])

  useEffect(()=>{
    set_filter_data(all_approved_transcript_request)
  },[all_approved_transcript_request])


  return (
    <>
   {isLoading?<Loader />:

    <Box>
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Status" width="130px" bg="var(--white-color)" 
            borderColor="var(dark-green-color)" onChange={(e:any)=>set_selected_status(e.target.value)}>
              <option>Approved</option>
              {/* <option>Dispatched</option> */}
              {/* <option>Pending</option> */}
          </Select>

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">GENERATE AND UPDATE TRANSCRIPT STATUS IN OPTIONS</Heading>
          <Text m="0" fontSize=".8rem">Showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {  filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              <Th sx={HeadStyle}>STUDENT NO</Th>
                <Th sx={HeadStyle}>DESTINATION</Th>
                <Th sx={HeadStyle}>ADDRESS</Th>
                <Th sx={HeadStyle}>AMOUNT</Th>
                {/* <Th sx={HeadStyle}>DISPATCH</Th> */}
                {/* <Th sx={HeadStyle}>COMMENT</Th> */}
                <Th sx={HeadStyle}>PAID</Th>
                <Th sx={HeadStyle}>Created Date</Th>
                <Th sx={HeadStyle}>Approved Date</Th>
                <Th sx={HeadStyle}>STATUS</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.StudentNo}>
                <Td sx={DataStyle}>{eCandidate.StudentNo}</Td>
                <Td sx={DataStyle}>{eCandidate.DestinationName}</Td>
                <Td sx={{...DataStyle,maxW:'250px'}}>{eCandidate.DestinationAddress.length > 40?eCandidate.DestinationAddress.slice(0,37)+"...":eCandidate.DestinationAddress}</Td>
                <Td sx={DataStyle}>{eCandidate.TranscriptAmount}</Td>
                {/* <Td sx={DataStyle}>{format(new Date(eCandidate.TranscriptDispatchDate), "dd/MM/yyyy")}</Td> */}
                {/* <Td sx={DataStyle}>{eCandidate.Comments}</Td> */}
                <Td sx={DataStyle}>{eCandidate.PaymentCompleted? 'Yes': 'No'}</Td>
                <Td sx={DataStyle}>
                  {format(new Date(eCandidate.ActionDate), "dd/MM/yyyy HH:mm")}
                </Td>
                <Td sx={DataStyle}>
                  {format(new Date(eCandidate.CreateDate), "dd/MM/yyyy HH:mm")}
                </Td>
                <Td sx={DataStyle}>{eCandidate.Status}</Td>
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                    <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eCandidate,update_status,statusLoading}}/></div>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Approved Transcript List'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}


const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}

const Option = (props: any) => {
  const index = props.index;
  const candidate = props.candidate;
  const update_status = props.update_status;
  const statusLoading = props.statusLoading;

  const [ind, set_index] = useAtom(indexAtom);
  const [, set_open] = useAtom(openAtom);
  const [, set_modal] = useAtom(modalAtom);
  
const UpdateTranscriptStatus = ({ candidate, update_status, statusLoading, onClose }: any) => {
  const [status, set_status] = useState<string>(candidate?.Status || '');

  const handleSubmit = () => {
    const payload = {
      id: candidate?.Id ?? candidate?.id ?? candidate?.TranscriptRequestId,
      status: status,
    };
    update_status(payload);
  };

  return (
    <Box p="16px" minW="300px">
      <Text mb="8px" fontWeight="bold">Student: {candidate?.StudentNo}</Text>
      <Select
        value={status}
        onChange={(e: any) => set_status(e.target.value)}
        mb="16px"
        isDisabled={statusLoading} 
      >
        <option value="Approved">Shipped</option>
        <option value="Dispatched">Dispatched</option>
        <option value="Completed">Completed</option>
        {/* <option value="Pending">Pending</option> */}
      </Select>
      <Button
        isLoading={statusLoading}     
        loadingText="Updating..."     
        onClick={handleSubmit}
        bg="var(--cipm-light-green)"
        w="100%"
        isDisabled={!status || statusLoading} 
      >
        Update Status
      </Button>
    </Box>
  );
};

  const onClick = () => {
    if (index === ind) {
      set_index(null);
      return;
    }
    set_index(index);
  };

  const handleGenerateTranscript = () => {
    set_index(null);
    set_modal({
      header: 'Generate Transcript',
      content: <Transcript {...candidate} />,
    });
    set_open(true);
  };

  const handleViewDetails = () => {
    set_index(null);
    set_modal({
      header: 'Candidate Details',
      content: <ViewDetails candidate={candidate} />,
    });
    set_open(true);
  };


 const handleUpdateStatus = () => {
    set_index(null);
    set_modal({
      header: 'Update Transcript Status',
      content: (
        <UpdateTranscriptStatus
          candidate={candidate}
          update_status={update_status}
          statusLoading={statusLoading}
          onClose={() => set_open(false)}
        />
      ),
    });
    set_open(true);
  };

useEffect(() => {
  return () => set_index(null);
}, []);

return (
    <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)">
          <MoreIcon />
        </Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleViewDetails}>
              View Details
            </GridItem>
            <GridItem sx={sx} p="8px 4px" onClick={handleGenerateTranscript}>
              Generate Transcript
            </GridItem>
            <GridItem sx={sx} p="8px 4px" onClick={handleUpdateStatus}>
              Update Transcript Status
            </GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
  
const ViewDetails = (props: any) => {
  const { viewDocument } = useDocumentModal();
  const c = props.candidate;

  // 🔹 All Documents
  const documents = [
    { label: "WES Form", path: c?.Path },
    { label: "Application Letter", path: c?.ApplicationLetterPath },
    { label: "Evidence For Request", path: c?.EvidenceForRequestPath },
    { label: "Induction Certificate", path: c?.InductionCertificatePath },
  ].filter((doc) => doc.path);

  const [currentIndex, setCurrentIndex] = useState<number | null>(null);

  return (
    <Flex flexDir="column" minWidth="600px" gap="30px">

      <Grid templateColumns="1fr" gap="20px">

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Student No</Text>
          <Text fontWeight="500">{c.StudentNo}</Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Destination</Text>
          <Text>{c.DestinationName || "N/A"}</Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Address</Text>
          <Text>{c.DestinationAddress || "N/A"}</Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Amount</Text>
          <Text>{c.TranscriptAmount || "N/A"}</Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Paid</Text>
          <Text>{c.PaymentCompleted ? "Yes" : "No"}</Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Created Date</Text>
          <Text>
            {c.CreateDate
              ? format(new Date(c.CreateDate), "dd/MM/yyyy HH:mm")
              : "N/A"}
          </Text>
        </GridItem>

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Approved Date</Text>
          <Text>
            {c.ActionDate
              ? format(new Date(c.ActionDate), "dd/MM/yyyy HH:mm")
              : "N/A"}
          </Text>
        </GridItem>
        {documents.map((doc, index) => (
          <GridItem key={doc.label}>
            <Flex gap="20px" align="center">
              <Text width="200px" fontWeight="bold">
                {doc.label}:
              </Text>

              <Flex
                align="center"
                gap="8px"
                cursor="pointer"
                color="blue.500"
                _hover={{ textDecoration: "underline" }}
                onClick={() => setCurrentIndex(index)}
              >
                <FaRegFileAlt />
                <Text fontSize="sm">View document</Text>
              </Flex>
            </Flex>
          </GridItem>
        ))}

        <GridItem as={Flex} gap="20px">
          <Text width="150px">Status</Text>
          <Text>{c.Status || "Pending"}</Text>
        </GridItem>

      </Grid>


      <Modal
        isOpen={currentIndex !== null}
        onClose={() => setCurrentIndex(null)}
        size="6xl"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {currentIndex !== null && documents[currentIndex].label}
          </ModalHeader>
          <ModalCloseButton />

          <ModalBody>

            {currentIndex !== null && (
              <>
                <iframe
                  src={encodeURI(documents[currentIndex].path!)}
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                />

                <Flex justify="space-between" mt={4} align="center">

                  <Button
                    onClick={() =>
                      setCurrentIndex((prev) =>
                        prev !== null && prev > 0 ? prev - 1 : prev
                      )
                    }
                    isDisabled={currentIndex === 0}
                  >
                    Previous
                  </Button>

                  <Text>
                    {currentIndex + 1} of {documents.length}
                  </Text>

                  <Button
                    onClick={() =>
                      setCurrentIndex((prev) =>
                        prev !== null && prev < documents.length - 1
                          ? prev + 1
                          : prev
                      )
                    }
                    isDisabled={currentIndex === documents.length - 1}
                  >
                    Next
                  </Button>

                </Flex>
              </>
            )}

          </ModalBody>
        </ModalContent>
      </Modal>

    </Flex>
  );
};

